let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7gF8f")).then(() => parcelRequire('j9sSr'));